export const API_TIMEOUT = 30000;

export const STORAGE_KEYS = {
  AUTH_STATE: 'authState',
  RESTAURANT_ID: 'restaurantId',
  USER_PREFERENCES: 'userPreferences',
} as const;

export const APP_CONFIG = {
  MAX_FILE_SIZE: 5 * 1024 * 1024,
  SUPPORTED_IMAGE_FORMATS: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
} as const;

export const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
] as const;

export const SAMPLE_AD_CARDS = [
  { title: 'Weekend Special', subtitle: '20% OFF All Orders', accent: '#EE4423' },
  { title: 'Happy Hour', subtitle: 'Buy 1 Get 1 Free', accent: '#F59E0B' },
  { title: 'New Menu Launch', subtitle: "Try Today's Special", accent: '#8E44AD' },
] as const;

export const toneMoodOptions = [
  'Sincere',
  'Narrative',
  'Creative',
  'Curious',
  'Playful',
  'Professional',
  'Friendly',
  'Inspirational',
] as const;

export const targetAudienceOptions = [
  'Families',
  'Young Adults',
  'Professionals',
  'Local Customers',
  'Tourists',
  'Students',
  'Couples',
  'Everyone',
] as const;

export const shortCodeOptions = [
  '/vintagePrint',
  '/gravitydefying',
  '/gravityexploded',
  '/productexplosion',
  '/glitch',
  '/gig',
  '/premiumFlyer',
  '/creativePoster',
  '/metopherdesign',
  '/fish eye',
  '/worms eye',
  '/droneview',
  '/ugc ad',
  '/3d render',
  '/bokeh',
  '/night scene',
  '/producthero',
  '/eventpromo',
  '/adcreative',
] as const;

const squareIcon = {
  viewBox: '0 0 24 24',
  path: 'M5 5h14v14H5V5Zm2 2v10h10V7H7Z',
} as const;

const landscapeIcon = {
  viewBox: '0 0 24 24',
  path: 'M3 7h18v10H3V7Zm2 2v6h14V9H5Z',
} as const;

const panoramicIcon = {
  viewBox: '0 0 24 24',
  path: 'M2 8h20v8H2V8Zm2 2v4h16v-4H4Z',
} as const;

const portraitIcon = {
  viewBox: '0 0 24 24',
  path: 'M7 3h10v18H7V3Zm2 2v14h6V5H9Z',
} as const;

export const aspectRatio = [
  { label: '1:1', value: '1:1', icon: squareIcon },
  { label: '21:9', value: '21:9', icon: panoramicIcon },
  { label: '16:9', value: '16:9', icon: landscapeIcon },
  { label: '9:16', value: '9:16', icon: portraitIcon },
  { label: '2:3', value: '2:3', icon: portraitIcon },
  { label: '3:4', value: '3:4', icon: portraitIcon },
  { label: '1:2', value: '1:2', icon: portraitIcon },
  { label: '2:1', value: '2:1', icon: landscapeIcon },
  { label: '3:1', value: '3:1', icon: panoramicIcon },
  { label: '1:3', value: '1:3', icon: portraitIcon },
  { label: '5:4', value: '5:4', icon: landscapeIcon },
  { label: '4:5', value: '4:5', icon: portraitIcon },
  { label: '3:2', value: '3:2', icon: landscapeIcon },
  { label: '4:3', value: '4:3', icon: landscapeIcon },
] as const;